import Hero from './components/Hero';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import LatestResources from './components/LatestResources';
import PopularResources from './components/PopularResources';
import SiteIntro from './components/SiteIntro';
import { useSeo } from '@/hooks/useSeo';

export default function Home() {
  useSeo({
    title: '免费91 - 优质免费资源分享平台',
    description:
      '免费91网站汇聚丰富的免费视频、软件、教程等资源，满足用户多样化的免费需求，方便快捷地获取所需内容。',
    keywords: '免费91,免费资源,免费视频,软件下载,免费教程,免费内容平台',
  });

  return (
    <>
      <Hero />
      <HeroCarousel />
      <CategoryEntries />
      <LatestResources />
      <PopularResources />
      <SiteIntro />
    </>
  );
}